import { ProjectStateTypes } from 'containers/projects/types/project'
import { IUser } from './user'

export interface ProjectModalState {
  isOpen?: boolean
}

export interface ProjectModalContextProps extends ProjectModalState {
  toggleModal: (id?: string) => void
}

export enum ProjectModalActionTypes {
  TOGGLE_MODAL = 'TOGGLE_MODAL',
}

export interface ProjectImageFormat {
  width?: number
  height?: number
}

export interface ProjectContent {
  description?: string
  hideImage?: boolean
  id?: string
  image?: string
  imageFormat?: ProjectImageFormat
  title?: string
  url?: string
}

export interface Project {
  id?: string
  title: string
  description?: string
  gallery?: string[]
  tags?: string[]
  links?: string[]
  content?: ProjectContent[]
  state?: ProjectStateTypes
}

export interface ProjectCreationState {
  project?: Project
  loading?: boolean
  error?: string
}

export interface ProjectResponseApi {
  user: IUser
  project: Project
}

export const projectCreationErrors = {
  title: 'Please enter a title',
  description: 'Please enter a description',
  contentType: 'Please select at least one content type',
  links: 'Please add at least one link',
}
